module.exports = __webpack_public_path__ + "img/delete.944a9c55.svg";